// Dynamic nutrition + allergen computation from product customization.
// All values are APPROXIMATE / DEMO unless supplied by the business.

const KEYS = ["calories", "protein", "carbs", "fat"];

function chosenOptions(product, selections) {
  const out = [];
  (product.modifierGroups || []).forEach((g) => {
    (selections[g.id] || []).forEach((optId) => {
      const opt = g.options.find((o) => o.id === optId);
      if (opt) out.push({ group: g, opt });
    });
  });
  return out;
}

// base × size multiplier, then signed modifier deltas (extras add, removals subtract).
export function computeNutrition(product, selections = {}) {
  const base = product.nutrition || { calories: 0, protein: 0, carbs: 0, fat: 0 };
  const result = { ...base };

  const sizeGroup = (product.modifierGroups || []).find((g) => g.id === "mg_size");
  if (sizeGroup) {
    const chosenId = (selections[sizeGroup.id] || [])[0];
    const opt = sizeGroup.options.find((o) => o.id === chosenId);
    if (opt?.nutritionMultiplier) {
      KEYS.forEach((k) => { result[k] = result[k] * opt.nutritionMultiplier; });
    }
  }

  chosenOptions(product, selections).forEach(({ group, opt }) => {
    if (group.id === "mg_size" || !opt.nutritionDelta) return;
    KEYS.forEach((k) => { result[k] += opt.nutritionDelta[k] || 0; });
  });

  KEYS.forEach((k) => { result[k] = Math.max(0, Math.round(result[k])); });
  return result;
}

// Removals apply to the base recipe first; additions are applied afterwards so
// an allergen re-introduced by an add-on (e.g. "no butter" + "extra cheese")
// is never dropped.
export function computeAllergens(product, selections = {}) {
  const set = new Set(product.allergens || []);
  const chosen = chosenOptions(product, selections);
  chosen.forEach(({ opt }) => (opt.allergensRemove || []).forEach((a) => set.delete(a)));
  chosen.forEach(({ opt }) => (opt.allergensAdd || []).forEach((a) => set.add(a)));
  return [...set];
}
